import { Layout as AntLayout } from 'antd';
import { Outlet } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter7Adapter, useUiConfig } from 'library';
import Sidebar from './Sidebar';
import Header from './Header';
import { resolveFooterText } from '../../utils/resolveFooterText';

const { Content, Footer } = AntLayout;

const Layout = () => {
  const { footerText } = useUiConfig();

  return (
    <QueryParamProvider adapter={ReactRouter7Adapter}>
      <AntLayout hasSider>
        <Sidebar />
        <AntLayout>
          <Header />
          <Content style={{ overflow: 'initial' }}>
            <Outlet />
          </Content>
          <Footer style={{ textAlign: 'center' }}>
            {resolveFooterText(footerText)}
          </Footer>
        </AntLayout>
      </AntLayout>
    </QueryParamProvider>
  );
};

export default Layout;
